import { Bell, AlertTriangle, UserCog, Folder, Cog, Gauge, File, Info, Type, SquareActivity, SlidersHorizontal } from 'lucide-react';

export const PERMISSIONS = {
      GLOBAL:{
        GLOBAL_EDIT: "global_edit"
      },

      SETTINGS:{
        VIEW_SETTINGS: "view_settings",
        VIEW_PROFILE: "view_profile",
        EDIT_PROFILE: "edit_profile",
        VIEW_SITES: "view_sites",
        EDIT_SITES: "edit_sites",
        VIEW_USERS: "view_users",
        EDIT_USERS: "edit_users"

      },

      ASSETS:{
        VIEW_ASSETS: "view_assets",
        EDIT_ASSETS: "edit_assets",
        VIEW_ASSETS_HIERARCHY: "view_assets_hierarchy",
        VIEW_ASSETS_LIST: "view_assets_list",
        VIEW_POINTS_LIST: "view_points_list",
        VIEW_POINTS_ANALYSIS: "view_points_analysis"
      },

      SCADA:{
        VIEW_SCADA: "view_scada"
      },  

      ALARMS:{
        VIEW_ALARMS: "view_alarms"
      }
};

export const UPDATE_TYPE_PROPERTIES = {
  alarms: {
    icon: Bell,
    color: 'red',
    label: 'Alarms'  
  },
  faults: {
    icon: AlertTriangle,
    color: 'orange',
    label: 'Faults'
  },
  readings: {
    icon: SquareActivity,
    color: 'emerald',
    label: 'Readings'
  }
};

export const NODE_UPDATE_TYPES = {
  Location: {
    alarms: UPDATE_TYPE_PROPERTIES.alarms,
    faults: UPDATE_TYPE_PROPERTIES.faults
  },
  Asset: {
    alarms: UPDATE_TYPE_PROPERTIES.alarms,
    faults: UPDATE_TYPE_PROPERTIES.faults
  },
  DataPoint: {
    readings: UPDATE_TYPE_PROPERTIES.readings
  },
  ControlPoint: {
    readings: UPDATE_TYPE_PROPERTIES.readings
  }
};

export const UPDATE_TYPES = {
  'alarms': false,
  'faults': false,
  'readings': true
  
};

export const NODE_TYPE_PROPERTIES = {
  Location: {
    icon: Folder,
    color: 'yellow'
  },
  Asset: {
    icon: Cog,
    color: 'indigo'
  },
  DataPoint: {
    icon: Gauge,
    color: 'blue'
  },
  ControlPoint: {
    icon: SlidersHorizontal,
    color: 'violet'
  },
  Document: {
    icon: File,
    color: 'amber'
  },
  Attribute: {
    icon: Info,
    color: 'blue'
  }
};

